// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ag-4";
export var closeButton = "_ag-6";
export var dismissButton = "_ag-3";
export var editImageWithAiContainer = "_ag-8";
export var imageUploadWrapper = "_ag-7";
export var misspelledWord = "_ag-5";
export var spellCheckContainer = "_ag-2";
export var spin = "_ag-1";
export var spinning = "_ag-0";